export const FETCH_ATTENDANCE_DETAILS_REQUEST = "FETCH_ATTENDANCE_DETAILS_REQUEST";
export const FETCH_ATTENDANCE_DETAILS_SUCCESS = "FETCH_ATTENDANCE_DETAILS_SUCCESS";
export const FETCH_ATTENDANCE_DETAILS_FAILURE = "FETCH_ATTENDANCE_DETAILS_FAILURE";

export const FETCH_ATTENDANCE_MONTHLY_REQUEST = "FETCH_ATTENDANCE_DETAILS_REQUEST";
export const FETCH_ATTENDANCE_MONTHLY_SUCCESS = "FETCH_ATTENDANCE_DETAILS_SUCCESS";
export const FETCH_ATTENDANCE_MONTHLY_FAILURE = "FETCH_ATTENDANCE_DETAILS_FAILURE";
